import { render, staticRenderFns } from "./maskComponent.vue?vue&type=template&id=e48eadd2&"
import script from "./maskComponent.vue?vue&type=script&lang=js&"
export * from "./maskComponent.vue?vue&type=script&lang=js&"
import style0 from "./maskComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports